export type RngState = number; // uint32
export interface RngCursor {
  s: RngState;
}

export function nextState(s: RngState): RngState {
  return (s + 0x6d2b79f5) >>> 0;
}

export function mix32(s: RngState): number {
  let t = s;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return (t ^ (t >>> 14)) >>> 0;
}

export function cursor(s: RngState): RngCursor {
  return { s: s >>> 0 };
}

/** [0, 1) */
export function nextFloat(c: RngCursor): number {
  c.s = nextState(c.s);
  return mix32(c.s) / 4294967296;
}

/** 0 <= 결과 < max. 편향은 max/2^32 이하라 게임 판정에 무의미하다. */
export function nextInt(c: RngCursor, max: number): number {
  return Math.floor(nextFloat(c) * max);
}

/** 제자리 Fisher-Yates. 이 구현이 곧 계약이다 — 바꾸면 ENGINE_VERSION 을 올린다. */
export function shuffle<T>(c: RngCursor, arr: T[]): T[] {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = nextInt(c, i + 1);
    const tmp = arr[i] as T;
    arr[i] = arr[j] as T;
    arr[j] = tmp;
  }
  return arr;
}

/** 앞 k개만 뽑는 부분 Fisher-Yates(무복원 추출). 사다리 창에서 오답을 뽑는다. */
export function takeK<T>(c: RngCursor, arr: T[], k: number): T[] {
  const n = Math.min(k, arr.length);
  for (let i = 0; i < n; i++) {
    const j = i + nextInt(c, arr.length - i);
    const tmp = arr[i] as T;
    arr[i] = arr[j] as T;
    arr[j] = tmp;
  }
  return arr.slice(0, n);
}

/** 문자열 시드 + 스트림 이름 → uint32 (xmur3) */
export function hashSeed(seed: string, stream: string): RngState {
  const text = `${seed}#${stream}`;
  let h = 1779033703 ^ text.length;
  for (let i = 0; i < text.length; i++) {
    h = Math.imul(h ^ text.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  h = Math.imul(h ^ (h >>> 16), 2246822507);
  h = Math.imul(h ^ (h >>> 13), 3266489909);
  return (h ^ (h >>> 16)) >>> 0;
}
